import { BEGIN, COMMIT, REVERT } from 'redux-optimistic-ui';
import { isPromise } from 'common/util';
let nextTransactionId = 0;
export default store => next => action => {
    const { type, meta, payload } = action;

    if (payload === undefined || meta === undefined) {
        return next(action);
    }

    if (!isPromise(payload)) {
        next(action);
    }

    const { isOptimistic } = meta;

    let transactionId;
    if (isOptimistic) {
        transactionId = nextTransactionId++;
        store.dispatch({ type, meta });
        next(
            Object.assign({}, action, {
                type: `${type}_BEGIN`,
                meta: Object.assign({}, meta, {
                    optimistic: {
                        type: BEGIN,
                        id: transactionId
                    }
                })
            })
        );
    } else {
        next({
            type: `${type}_PENDING`,
            origin: action
        });
    }

    const resolve = value => {
        const success = createAction({
            payload: value,
            meta,
            type,
            isSuccess: true,
            isOptimistic,
            transactionId
        });
        next(success);
        return value;
    };

    const reject = async error => {
        const errorDetails = await error;
        const fail = createAction({
            payload: errorDetails,
            meta,
            type,
            isSuccess: false,
            isOptimistic,
            transactionId
        });
        next(fail);
        throw errorDetails;
    };

    return payload.then(resolve, reject);
};

function createAction({
    payload,
    meta,
    type,
    isSuccess,
    isOptimistic,
    transactionId
}) {
    return {
        type: isOptimistic
            ? `${type}_${isSuccess ? 'COMMIT' : 'REVERT'}`
            : `${type}_${isSuccess ? 'COMPLETED' : 'FAILED'}`,
        payload,
        meta: isOptimistic
            ? Object.assign({}, meta, {
                  optimistic: {
                      type: isSuccess ? COMMIT : REVERT,
                      id: transactionId
                  }
              })
            : meta
    };
}
